import React, { useState, useEffect } from "react";
import { FaUser } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import axios from "axios";
import "./AccountOwner.scss";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";

function AccountOwner() {
  const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

  const [details, setDetails] = useState(null);
  const [error, setError] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [step, setStep] = useState(1);

  const [accountOwnerDetails, setAccountOwnerDetails] = useState(null);

  const now = new Date();
  const pad = (n) => (n < 10 ? "0" + n : n);
  const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate()
  )}T${pad(now.getHours())}:${pad(now.getMinutes())}`;

  const location = useLocation();
  const passedState = location.state;

  useEffect(() => {
    if (passedState?.mode === "edit" && passedState.formData) {
      const data = passedState.formData;
      setFormData({
        primaryName: data.primaryContact?.name || "",
        primaryPhone: data.primaryContact?.contactNumber || "",
        primaryEmail: data.primaryContact?.email || "",
        secondaryName: data.secondaryContact?.name || "",
        secondaryPhone: data.secondaryContact?.contactNumber || "",
        secondaryEmail: data.secondaryContact?.email || "",
        address: data.billingAddress?.address || "",
        country: data.billingAddress?.country || "",
        state: data.billingAddress?.state || "",
        pinCode: data.billingAddress?.pinCode || "",
        school: data.education?.school || "",
        degree: data.education?.degree || "",
        edustartdate: data.education?.edustartdate || "",
        eduenddate: data.education?.eduenddate || "",
        designation: data.experience?.designation || "",
        company: data.experience?.company || "",
        comstartdate: data.experience?.comstartdate || "",
        comenddate: data.experience?.comenddate || "",
        currentlyWorking: Boolean(data.experience?.currentlyWorking),
        skills: data.skills?.skills || "",
        about: data.skills?.about || "",
        linkedIn: data.skills?.linkedIn || "",
        gitHub: data.skills?.gitHub || "",
      });
    }
  }, [passedState]);

  const [formData, setFormData] = useState({
    primaryName: "",
    primaryPhone: "",
    primaryEmail: "",
    secondaryName: "",
    secondaryPhone: "",
    secondaryEmail: "",
    address: "",
    country: "",
    state: "",
    pinCode: "",
    school: "",
    degree: "",
    edustartdate: "",
    eduenddate: "",
    designation: "",
    company: "",
    comstartdate: "",
    comenddate: "",
    currentlyWorking: false,
    skills: "",
    about: "",
    linkedIn: "",
    gitHub: "",
  });

  const [errors, setErrors] = useState({});
  useEffect(() => {
    axios
      .get("https://countriesnow.space/api/v0.1/countries/codes")
      .then((response) => {
        if (Array.isArray(response.data.data)) {
          console.log(response.data);
          setCountryList(response.data.data);
        } else {
          console.error("Unexpected data format:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching countries:", error);
      });
  }, []);

  const handleChange = (field, event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleChangeCheckbox = (field, event) => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    setFormData({ ...formData, [field]: value });
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.primaryName.trim())
      newErrors.primaryName = "Primary name is required";
    if (!formData.primaryPhone.trim())
      newErrors.primaryPhone = "Primary contact number is required";
    if (!formData.primaryEmail.trim())
      newErrors.primaryEmail = "Primary email is required";
    if (!/\S+@\S+\.\S+/.test(formData.primaryEmail))
      newErrors.primaryEmail = "Primary email is invalid";
    if (!formData.address.trim()) newErrors.address = "Address is required";
    if (!formData.country.trim()) newErrors.country = "Country is required";
    if (!formData.school.trim()) newErrors.school = "Instituion is required";
    if (!formData.degree.trim()) newErrors.degree = "Degree is required";
    if (!formData.edustartdate.trim())
      newErrors.edustartdate = "Start Date is required";
    if (!formData.eduenddate.trim())
      newErrors.eduenddate = "End Date is required";
    if (!formData.designation.trim())
      newErrors.designation = "Designation is required";
    if (!formData.company.trim())
      newErrors.company = "Company Name is required";
    if (!formData.comstartdate.trim())
      newErrors.comstartdate = "Start Date is required";
    if (!formData.skills.trim()) newErrors.skills = "Skills is required";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validate();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const payload = {
        primaryContact: {
          name: formData.primaryName,
          contactNumber: formData.primaryPhone,
          email: formData.primaryEmail,
        },
        secondaryContact: {
          name: formData.secondaryName,
          contactNumber: formData.secondaryPhone,
          email: formData.secondaryEmail,
        },
        billingAddress: {
          address: formData.address,
          country: formData.country,
          state: formData.state,
          pinCode: formData.pinCode,
        },
        education: {
          school: formData.school,
          degree: formData.degree,
          edustartdate: formData.edustartdate,
          eduenddate: formData.eduenddate,
        },
        experience: {
          designation: formData.designation,
          company: formData.company,
          comstartdate: formData.comstartdate,
          comenddate: formData.comenddate,
          currentlyWorking: formData.currentlyWorking,
        },
        skills: {
          skills: formData.skills,
          about: formData.about,
          linkedIn: formData.linkedIn,
          gitHub: formData.gitHub,
        },
      };

      await axios.post(`${baseURL}/api/account-owner`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
 Swal.fire({
        icon: "success",
        title: "Form submitted successfully!",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      })
      setFormData("");

      await fetchAccountOwnerDetails();

      console.log("Error", formData);
    } catch (error) {
      console.error("Error submitting form", error);
 Swal.fire({
        icon: "error",
        title: "Failed to submit form",
        confirmButtonColor: "#FCB124",
        confirmButtonText: "OK",
      })    }
  };

  const fetchAccountOwnerDetails = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(`${baseURL}/api/account-owner`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("fetchAccountOwnerDetails data:", response.data);

      if (
        response.data.accountOwnerDetails &&
        Array.isArray(response.data.accountOwnerDetails)
      ) {
        const ownerDetails = response.data.accountOwnerDetails[0];
        setAccountOwnerDetails(ownerDetails.primaryContact);
        setDetails(ownerDetails);
      }
    } catch (err) {
      console.error("Error fetching account owner details:", err);
      setError("Failed to load details.");
    }
  };

  useEffect(() => {
    fetchAccountOwnerDetails();
  }, []);

  const nextStep = () => {
    setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setStep((prev) => prev - 1);
  };

  return (
    <div>
        <div className="popup-content">
          {step === 1 && (
            <>
              <div className="header-left">
                <span className="header-icon">
                  <FaUser />
                </span>
                <div className="form-title">Account Owner Details</div>
              </div>
              <form>
                <div className="form-section-wrapper">
                  <div className="form-section">
                    <p className="section-title">Primary contact</p>
                    {errors.primaryName && (
                      <span className="error">{errors.primaryName}</span>
                    )}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Name *"
                        value={formData.primaryName}
                        onChange={(e) => handleChange("primaryName", e)}
                        required
                      />

                      <span className="input-icon">
                        <FaUser style={{ marginRight: "45px" }} />
                      </span>
                    </div>
                    {errors.primaryPhone && (
                      <span className="error">{errors.primaryPhone}</span>
                    )}
                    <div
                      className="input-wrapper"
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <select
                          className="country-code"
                          style={{
                            border: "none",
                            borderRadius: "0px",
                            width: "70px",
                            height: "35px",
                            fontSize: "14px",
                            marginLeft: "0.8px",
                            background: "transparent",
                          }}
                        >
                          {countryList.map((country, index) => (
                            <option key={index} value={country.dial_code}>
                              ({country.dial_code})
                            </option>
                          ))}
                        </select>
                      </div>

                      <input
                        type="tel"
                        placeholder="Contact Number *"
                        style={{
                          paddingLeft: "80px",
                          marginTop: "0",
                          minWidth: "20%",
                        }}
                        value={formData.primaryPhone}
                        onChange={(e) => handleChange("primaryPhone", e)}
                      />

                      <span
                        className="input-icon"
                        style={{ position: "absolute", right: "55px" }}
                      >
                        <FaPhone />
                      </span>
                    </div>
                    {errors.primaryEmail && (
                      <span className="error">{errors.primaryEmail}</span>
                    )}
                    <div className="input-wrapper">
                      <input
                        type="email"
                        placeholder="Email id *"
                        value={formData.primaryEmail}
                        onChange={(e) => handleChange("primaryEmail", e)}
                        required
                      />
                      <span className="input-icon">
                        <MdEmail style={{ marginRight: "45px" }} />
                      </span>
                    </div>
                  </div>
                  <div className="form-section">
                    <p className="section-title">Secondary contact</p>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Name *"
                        value={formData.secondaryName}
                        onChange={(e) => handleChange("secondaryName", e)}
                      />
                      <span className="input-icon">
                        <FaUser style={{ marginRight: "45px" }} />
                      </span>
                    </div>
                    <div
                      className="input-wrapper"
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <select
                          className="country-code"
                          style={{
                            border: "none",
                            borderRadius: "0px",
                            width: "70px",
                            height: "35px",
                            fontSize: "14px",
                            marginLeft: "0.8px",
                            background: "transparent",
                          }}
                        >
                          {countryList.map((country, index) => (
                            <option key={index} value={country.dial_code}>
                              ({country.dial_code})
                            </option>
                          ))}
                        </select>
                      </div>
                      <input
                        type="tel"
                        placeholder="Contact Number *"
                        style={{
                          paddingLeft: "80px",
                          marginTop: "0",
                          minWidth: "20%",
                        }}
                        value={formData.secondaryPhone}
                        onChange={(e) => handleChange("secondaryPhone", e)}
                      />
                      <span
                        className="input-icon"
                        style={{ position: "absolute", right: "55px" }}
                      >
                        <FaPhone />
                      </span>
                    </div>

                    <div className="input-wrapper">
                      <input
                        type="email"
                        placeholder="Email id"
                        value={formData.secondaryEmail}
                        onChange={(e) => handleChange("secondaryEmail", e)}
                      />
                      <span className="input-icon">
                        <MdEmail
                          style={{ marginRight: "45px", fontSize: "15px" }}
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="billing-section">
                  <p className="section-title" style={{ marginRight: "35px" }}>
                    Billing address
                  </p>

                  <div style={{ display: "flex" }}>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Address"
                        value={formData.address}
                        onChange={(e) => handleChange("address", e)}
                      />

                      <span className="input-icon">
                        <FaLocationDot style={{ marginRight: "80px" }} />
                      </span>
                    </div>

                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Pin code"
                        value={formData.pinCode}
                        onChange={(e) => handleChange("pinCode", e)}
                      />
                    </div>
                  </div>

                  <div className="input-wrapper" style={{ display: "flex" }}>
                    {/* Country field with select inside input */}
                    <div style={{ position: "relative", flex: 1 }}>
                      {errors.country && (
                        <span
                          className="error"
                          style={{ marginRight: "100px" }}
                        >
                          {errors.country}
                        </span>
                      )}
                      <select
                        className="country-code"
                        style={{
                          width: " 80%",
                          padding: "5px 35px 10px 10px",
                          border: " 1px solid #ccc",
                          borderRadius: "5px",
                          transform: "translateY(-50%)",
                          marginTop: "25px",
                          background: "transparent",
                          fontSize: "14px",
                          height: "70%",
                          outline: "none",
                          cursor: "pointer",
                        }}
                        value={formData.country}
                        onChange={(e) => handleChange("country", e)}
                      >
                        {countryList.map((country, index) => (
                          <option key={index} value={country.name}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* State field */}

                    <div className="input-wrapper" style={{ flex: 1 }}>
                      <input
                        type="text"
                        placeholder="State"
                        style={{
                          height: "20px",
                          fontSize: "14px",
                          marginRight: "20px",
                        }}
                        value={formData.state}
                        onChange={(e) => handleChange("state", e)}
                      />
                    </div>
                  </div>
                </div>

                <div className="popup-footer">
                  <button
                    onClick={nextStep}
                    className="save-btn"
                    style={{ marginLeft: "65%" }}
                  >
                    Next
                  </button>
                </div>
              </form>{" "}
            </>
          )}

          {step === 2 && (
            <>
              <form>
                <div className="form-section-wrapper">
                  <div className="form-section">
                    <div className="section-title">Education</div>
                    {errors.school && (
                      <span className="error">{errors.school}</span>
                    )}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="School or insituion *"
                        value={formData.school}
                        onChange={(e) => handleChange("school", e)}
                        required
                      />
                    </div>
                    {errors.degree && (
                      <span className="error">{errors.degree}</span>
                    )}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Degree *"
                        value={formData.degree}
                        onChange={(e) => handleChange("degree", e)}
                      />
                    </div>

                    <div
                      className="input-wrapper"
                      style={{ flexDirection: "column" }}
                    >
                      {errors.edustartdate && (
                        <span className="error">{errors.edustartdate}</span>
                      )}
                      <label>Start Date</label>
                      <input
                        type="date"
                        style={{ boxSizing: "border-box" }}
                        value={formData.edustartdate}
                        onChange={(e) => handleChange("edustartdate", e)}
                        required
                      />
                    </div>

                    <div
                      className="input-wrapper"
                      style={{ flexDirection: "column" }}
                    >
                      {errors.eduenddate && (
                        <span className="error">{errors.eduenddate}</span>
                      )}
                      <label>End Date</label>
                      <input
                        type="date"
                        style={{ boxSizing: "border-box" }}
                        value={formData.eduenddate}
                        onChange={(e) => handleChange("eduenddate", e)}
                        min={formData.edustartdate}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-section">
                    <div
                      className="section-title"
                      style={{ marginTop: "20px" }}
                    >
                      Experience
                    </div>
                    {errors.designation && (
                      <span className="error">{errors.designation}</span>
                    )}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Designation *"
                        value={formData.designation}
                        onChange={(e) => handleChange("designation", e)}
                      />
                    </div>
                    {errors.company && (
                      <span className="error">{errors.company}</span>
                    )}
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Company or Organization"
                        value={formData.company}
                        onChange={(e) => handleChange("company", e)}
                      />
                    </div>
                    {errors.comstartdate && (
                      <span className="error">{errors.comstartdate}</span>
                    )}
                    <div
                      className="input-wrapper"
                      style={{ flexDirection: "column" }}
                    >
                      <label>Start Date</label>
                      <input
                        type="date"
                        style={{ boxSizing: "border-box" }}
                        value={formData.comstartdate}
                        onChange={(e) => handleChange("comstartdate", e)}
                        required
                      />
                    </div>

                    <div
                      className="input-wrapper"
                      style={{ flexDirection: "column" }}
                    >
                      <label>End Date</label>
                      <input
                        type="date"
                        style={{ boxSizing: "border-box" }}
                        value={formData.comenddate}
                        onChange={(e) => handleChange("comenddate", e)}
                        min={formData.comstartdate}
                        disabled={formData.currentlyWorking}
                        required
                      />
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <label style={{ width: "100%", paddingTop: "2px" }}>
                        I am Currently working here
                      </label>
                      <div>
                        <input
                          style={{ width: "20px", MarginTop: "50px" }}
                          type="checkbox"
                          checked={formData.currentlyWorking}
                          onChange={(e) =>
                            handleChangeCheckbox("currentlyWorking", e)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="billing-section">
                  <div
                    className="section-title"
                    style={{ marginRight: "25px" }}
                  >
                    Skills
                  </div>
                  <div style={{ display: "flex" }}>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Skills"
                        style={{ height: "20px" }}
                        value={formData.skills}
                        onChange={(e) => handleChange("skills", e)}
                      />
                    </div>
                    <div className="input-wrapper">
                      <textarea
                        type="text"
                        placeholder="About"
                        value={formData.about}
                        onChange={(e) => handleChange("about", e)}
                        style={{ height: "20px" }}
                      />
                    </div>
                  </div>
                  <div
                    className="input-wrapper"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    {/* State field */}
                    <div style={{ flex: 1 }}>
                      <input
                        type="text"
                        placeholder="LinkedIn"
                        className="input-wrapper"
                        style={{
                          height: "20px",
                          fontSize: "14px",
                          width: "200px",
                        }}
                        value={formData.linkedIn}
                        onChange={(e) => handleChange("linkedIn", e)}
                      />
                    </div>

                    {/* Pincode field */}
                    <div style={{ flex: 1 }}>
                      <input
                        type="text"
                        placeholder="GitHub"
                        className="input-wrapper"
                        style={{
                          height: "20px",
                          fontSize: "14px",
                          width: "200px",
                        }}
                        value={formData.gitHub}
                        onChange={(e) => handleChange("gitHub", e)}
                      />
                    </div>
                  </div>
                </div>

                <div className="popup-footer">
                  <button onClick={prevStep} className="save-btn">
                    Back
                  </button>{" "}
                  &nbsp;
                  <button className="save-btn" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              </form>{" "}
            </>
          )}
        </div>
    </div>
  );
}

export default AccountOwner;
